import ReactGA from "react-ga4";

type AnalyticsValue = string | number | boolean | null | undefined;
export type AnalyticsEventParams = Record<string, AnalyticsValue>;

const sanitizeParams = (params: AnalyticsEventParams) =>
  Object.fromEntries(Object.entries(params).filter(([, value]) => value !== undefined && value !== null));

export const trackEvent = (eventName: string, params: AnalyticsEventParams = {}) => {
  if (!eventName) return;
  try {
    ReactGA.event(eventName, sanitizeParams(params));
  } catch {
    // noop
  }
};
